/**
 * Supabase Client for Admin Dashboard
 * Connects to the same database as the mobile app
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase credentials not found!')
  console.log('Please create .env file in apps/admin-web with:')
  console.log('VITE_SUPABASE_URL=your_supabase_url')
  console.log('VITE_SUPABASE_ANON_KEY=your_anon_key')
}

export const supabase = createClient(supabaseUrl!, supabaseAnonKey!, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
})

// Database types (shared with mobile app)
export interface Database {
  public: {
    Tables: {
      churches: {
        Row: {
          id: string
          name: string
          address: string | null
          phone_number: string | null
          created_at: string
        }
      }
      members: {
        Row: {
          id: string
          church_id: string
          preferred_name: string
          phone_number: string
          email: string | null
          role: 'admin' | 'pastor' | 'leader' | 'member'
          created_at: string
        }
      }
      events: {
        Row: {
          id: string
          church_id: string
          title: string
          description: string | null
          event_type: string
          start_datetime: string
          end_datetime: string | null
          location: string | null
          created_at: string
        }
      }
      prayers: {
        Row: {
          id: string
          church_id: string
          member_id: string
          title: string
          description: string | null
          prayer_count: number
          is_answered: boolean
          created_at: string
        }
      }
      giving: {
        Row: {
          id: string
          church_id: string
          member_id: string
          amount: number
          payment_method: string
          category: string
          transaction_reference: string | null
          created_at: string
        }
      }
      evangelism_contacts: {
        Row: {
          id: string
          church_id: string
          leader_id: string
          name: string
          phone_number: string | null
          spiritual_stage: string
          notes: string | null
          created_at: string
        }
      }
    }
  }
}
